import { parseCurrency, toCents } from 'components/Widget/shared/currency';
import type { CalculatorFieldValues } from 'components/Widget/shared/types';
import { CURRENT_SAVINGS_FIELD, EXPENSE_FIELDS, FLAT_GOAL_AMOUNT, MONTHLY_CONTRIBUTION_FIELD } from './constants';
import type { EmergencyFundResult, FundGoalKey } from './types';

/** Legacy rendered `1 months`. */
export const formatMonths = (months: number): string => `${months} ${months === 1 ? 'month' : 'months'}`;

const resolveGoal = (goalKey: FundGoalKey, monthlyExpenses: number): number =>
  goalKey === 'flat-1000' ? FLAT_GOAL_AMOUNT : Number(goalKey) * monthlyExpenses;

export const calculateEmergencyFund = (values: CalculatorFieldValues, goalKey: FundGoalKey): EmergencyFundResult => {
  const monthlyExpenses = EXPENSE_FIELDS.reduce((total, field) => total + parseCurrency(values[field.label] ?? ''), 0);
  const monthlyContribution = parseCurrency(values[MONTHLY_CONTRIBUTION_FIELD.label] ?? '');
  const alreadySaved = parseCurrency(values[CURRENT_SAVINGS_FIELD.label] ?? '');
  const goal = resolveGoal(goalKey, monthlyExpenses);
  // Savings past the goal leave nothing to save, rather than a negative timeline.
  const remaining = Math.max(0, goal - alreadySaved);
  // Dividing in cents keeps float drift in the dollar figures from tipping the ceiling into an extra month.
  const contributionInCents = toCents(monthlyContribution);

  return {
    monthlyExpenses,
    monthlyContribution,
    goal,
    // Legacy's Infinity and NaN paths both rendered as `-`; null carries that to the panel.
    monthsToGoal: contributionInCents === 0 ? null : Math.ceil(toCents(remaining) / contributionInCents),
  };
};
